import { render, staticRenderFns } from "./EkycWaiting.vue?vue&type=template&id=b9c5881e&scoped=true&"
import script from "./EkycWaiting.vue?vue&type=script&lang=ts&"
export * from "./EkycWaiting.vue?vue&type=script&lang=ts&"
import style0 from "./EkycWaiting.vue?vue&type=style&index=0&id=b9c5881e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c5881e",
  null
  
)

export default component.exports